import React, { Component } from 'react';

class Notice extends Component {
  getNoticeContelts = ()=>{
    if (this.props.currentEventInfo && this.props.currentEventInfo.eventInfo && this.props.currentEventInfo.eventInfo.note) {
      const result = this.props.currentEventInfo.eventInfo.note.split('\n')
      .map( (rowText, index) =>{
        return <li key={index}>{rowText.replace('\r', '')}</li>;
      });
      console.log('result :>> ', result);
      return result;
    } else {
      return '';
    }
  }

  render() {
    return (
      <div className='re_notice_w'>
        <h4 className='re_notice_title'>이벤트 주의사항</h4>
        <ul className='re_notice_list'>
          {this.getNoticeContelts()}
        </ul>
      </div>
    );
  }
}

export default Notice; 